import styled from 'styled-components';
import GoodsItem from './goodsItem'
export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 5px 12px calc(70px + env(safe-area-inset-bottom, 0px));
    direction: rtl;
    background: ${({ theme }) => theme.colors.bg};
    border-radius: ${({ theme }) => theme.radii.lg};
    &::-webkit-scrollbar {
        width: 0;
    }
`

export const ScrollHeaderBlock = styled.div`
    width: 100%;
    /* padding-bottom: 4px; */
`

export const BelowStickyBlock = styled.div`
    width: 100%;
`

export const StickyHeaderSlot = styled.div`
    position: sticky;
    top: 0;
    z-index: 10;
    margin: 0 0.5rem;
    padding: 0.625rem 0.75rem;
    border-radius: 1rem;
    /* Apple Liquid Glass approximation — same recipe as OrderActionDock */
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.45) 0%,
        rgba(255, 255, 255, 0.22) 40%,
        rgba(255, 255, 255, 0.18) 70%,
        rgba(255, 255, 255, 0.28) 100%
    );
    border: 1px solid rgba(255, 255, 255, 0.35);
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.55),
        inset 0 -0.5px 0 rgba(255, 255, 255, 0.06),
        0 6px 18px -10px rgba(0, 0, 0, 0.18),
        0 18px 32px -22px rgba(0, 0, 0, 0.12);
    backdrop-filter: blur(28px) saturate(180%);
    -webkit-backdrop-filter: blur(28px) saturate(180%);
`

export const GoodsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 16px;
    align-items: start;
    @media (max-width: 1199px) {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    @media (max-width: 900px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
    }
`
const Overlay = styled.div`
    position: absolute;
    background: rgba(0,0,0, 0.05);
    width: 100%;
    height: 100%;
    border-radius: 10px;
    z-index: 99;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    gap: 1em;
    img {
        min-width: 330px;
    }
`
export const TextWrapper = styled.div`
    padding: 1em;
    border-radius: 30px;
    background: ${props => props.$main ? '#eff3f4' : '#fff'};
    color: #7d7b79;
`
export default function GoodsList({goodsList, setProduct, product, chengeAkpaca, packegeList,
     goodsListDefault, setProductDefault, getMlai, getMhir, presetWindow, filterClose, collectDataProduct,filterGoodsValue,
     dateForAmlaca, setOrderTotal, orderTotal, isEditArizot, allowCreateOrder, isEditPrice, getGoodPrice,
     isLoadPrice, getLastPrice, stickyHeader, scrollHeader, belowSticky,
    }) {
    return(
        <Wrapper >
            {scrollHeader ? <ScrollHeaderBlock>{scrollHeader}</ScrollHeaderBlock> : null}
            {stickyHeader ? <StickyHeaderSlot>{stickyHeader}</StickyHeaderSlot> : null}
            {belowSticky ? <BelowStickyBlock>{belowSticky}</BelowStickyBlock> : null}
            {
                !allowCreateOrder?.isAllow &&
                    <Overlay>
                        <TextWrapper>
                            ניתן לבצע הזמנה עד - {allowCreateOrder?.expiredTime}
                        </TextWrapper>
                    </Overlay>
            }
            <GoodsGrid>
                {goodsList.map(item => <GoodsItem key={item.id}{...item}
                  setProduct={setProduct}
                  presetWindow={presetWindow}
                  setProductDefault={setProductDefault}
                  goodsListDefault={goodsListDefault}
                  product={product} chengeAkpaca={chengeAkpaca}
                  goodsList={goodsList}
                  getMlai={getMlai}
                  getMhir={getMhir}
                  packegeList={packegeList}
                  filterClose={filterClose}
                  collectDataProduct={collectDataProduct}
                  filterGoodsValue={filterGoodsValue}
                  dateForAmlaca={dateForAmlaca}
                  setOrderTotal={setOrderTotal}
                  orderTotal={orderTotal}
                  isEditArizot={isEditArizot}
                  isEditPrice={isEditPrice}
                  item={item}
                  getGoodPrice={getGoodPrice}
                  isLoadPrice={isLoadPrice}
                  getLastPrice={getLastPrice}
                />)}
            </GoodsGrid>
        </Wrapper>
    );
}